
<template>
    <nav class="panel">
        <p class="panel-heading">
            Invoice Details
        </p>
        <a class="panel-block" v-for="item in list">
            <span class="panel-icon">
              <i class="far fa-file-pdf"></i>
            </span>
            {{ item.name }}
            {{ item.street }},
            {{ item.city }},
            {{ item.country }},
            {{ item.phone }},
            {{ item.email }},
            {{ item.tax_id }},
            {{ item.ruc }},
        </a>
        <div class="panel-block">
            <button class="button is-link is-outlined is-fullwidth" @click="createForm = !createForm">
                + create new
            </button>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="invoice.name" class="input" placeholder="Name">
                    <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                </span>
                    <p v-if="errors.country" class="help is-danger">{{ errors.country[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field is-fullwidth">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="invoice.street" class="input" placeholder="Street">
                    <span class="icon is-small is-left">
                    <i class="fas fa-road"></i>
                </span>
                    <p v-if="errors.country" class="help is-danger">{{ errors.country[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field is-fullwidth">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="invoice.city" class="input" placeholder="City">
                    <span class="icon is-small is-left">
                        <i class="fas fa-building"></i>
                    </span>
                    <p v-if="errors.country" class="help is-danger">{{ errors.country[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field is-fullwidth">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <div class="select is-fullwidth">
                        <select v-model="invoice.country">
                            <option value="" hidden disabled>Country</option>
                            <option v-for="country in countries">{{ country.name }}</option>
                        </select>
                    </div>
                    <span class="icon is-small is-left">
                    <i class="fas fa-globe"></i>
                </span>
                    <p v-if="errors.country" class="help is-danger">{{ errors.country[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="invoice.phone" class="input" placeholder="Phone">
                    <span class="icon is-left">
                    <i class="fas fa-phone"></i>
                </span>
                    <p v-if="errors.country" class="help is-danger">{{ errors.country[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="invoice.email" class="input" placeholder="email">
                    <span class="icon is-left">
                    <i class="fas fa-envelope"></i>
                </span>
                    <p v-if="errors.email" class="help is-danger">{{ errors.email[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="invoice.tax_id" class="input" placeholder="Tax Id">
                    <span class="icon is-left">
                    <i class="fas fa-id-card"></i>
                </span>
                    <p v-if="errors.tax_id" class="help is-danger">{{ errors.tax_id[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="invoice.ruc" class="input" placeholder="RUC">
                    <span class="icon is-left">
                    <i class="fas fa-cog"></i>
                </span>
                    <p v-if="errors.ruc" class="help is-danger">{{ errors.ruc[0] }}</p>
                </div>
            </div>
        </div>
        <div class="panel-block" v-if="createForm">
            <div class="field">
                <button class="button is-primary is-fullwidth" @click.prevent="createNewItem" :class="{ 'is-loading': isLoading }">
                    Save
                </button>
            </div>
        </div>
    </nav>
</template>

<script>
    import apiInvoiceContactDetails from '../../api/apiInvoiceContactDetails'
    import axios from 'axios'
    export default {
        data () {
            return {
                createForm: false,
                isLoading: false,
                countries:[],
                list:[],
                invoice: {
                    user_id: this.$route.params.id,
                    name: '',
                    street: '',
                    city: '',
                    country: '',
                    phone: '',
                    email: '',
                    tax_id: '',
                    ruc: ''
                },
                errors: {
                    name: '',
                    street: '',
                    city: '',
                    country: '',
                    phone: '',
                    email: '',
                    tax_id: '',
                    ruc: ''
                }
            }
        },
        methods: {
            createNewItem() {
                this.isLoading = true
                this.clearAllErrors()
                console.log(this.invoice)
                apiInvoiceContactDetails
                    .createInvoiceContactDetailsRequest(this.invoice)
                    .then(response => {
                        this.isLoading = false
                        this.list.push(response.data)
                        this.clearForm()
                    })
                    .catch((err) => {
                        this.isLoading = false
                        if ( err.response && err.response.status === 422 ) {
                            this.errors = err.response.data
                        }
                    })
            },
            clearAllErrors() {
                this.errors = {
                    name: '',
                    street: '',
                    city: '',
                    country: '',
                    phone: '',
                    email: '',
                    tax_id: '',
                    ruc: ''
                }
            },
            clearForm() {
                this.createForm = false
                this.invoice = {
                    user_id: this.$route.params.id,
                    name: '',
                    street: '',
                    city: '',
                    country: '',
                    phone: '',
                    email: '',
                    tax_id: '',
                    ruc: ''
                }
            }
        },
        created () {
            this.invoice.user_id = this.$route.params.id
            apiInvoiceContactDetails
                .invoiceContactDetailsListRequest(this.invoice.user_id)
                .then(response => {
                    this.list = response.data
                })
                .catch(err => console.log(err))
        },
        mounted () {
            axios.get('https://restcountries.com/v3.1/all?fields=name')
                .then((response) => {
                    this.countries = response.data
                })
        }
    }
</script>

<style scoped>
    .field {
        width: 100%;
    }
</style>




// WEBPACK FOOTER //
// src/components/Profile/InvoiceDetails.vue